<template>
  <a-card :bordered="false">
    <!-- 查询条件 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="queryForm">
        <a-row :gutter="24">
          <a-col :md="8" :sm="24">
            <a-form-item label="开始时间">
              <a-date-picker
                v-decorator="['startTime']"
                placeholder="请选择开始时间"
                :format="dateFormat"
                :disabledDate="disabledStartDate"  style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="结束时间">
              <a-date-picker
                v-decorator="['endTime']"
                placeholder="请选择结束时间"
                :format="dateFormat"
                :disabledDate="disabledEndDate"    style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
<!--              <a-button type="primary" @click="searchQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              <a-button style="margin-left: 8px" type="primary" icon="download" @click="handleExport('用戶登錄統計')">导出</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button style="margin-left: 8px" type="primary" icon="download" @click="handleExport('用戶登錄統計')">{{language['common.exportButton']}}</a-button>
    </div>
    <!-- 自定义表头容器 -->
<!--    <div ref="headerContainer" class="custom-header-container">
      <div ref="headerContent" class="header-content">
        <div v-if="customHeaderHtml" v-html="customHeaderHtml"></div>
      </div>
    </div>-->
    <div class="custom-header-wrapper" v-if="statisticsData || loading">
      <div ref="fixedHeader" class="fixed-header-container">
        <div v-if="fixedHeaderHtml" v-html="fixedHeaderHtml"></div>
      </div>

      <div ref="scrollHeaderContainer" class="scroll-header-container">
        <div ref="scrollHeaderContent" class="header-content">
          <div v-if="scrollHeaderHtml" v-html="scrollHeaderHtml"></div>
        </div>
      </div>
    </div>
    <!-- 统计表格 -->
<!--    <div class="table-wrapper">-->
      <a-table
        ref="table"
        v-if="statisticsData || loading"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :scroll="{ x: scrollX }"
        bordered
        size="middle"
        :showHeader="false"
        class="custom-table login-statistics-table"
        :loading="loading"
        @scroll="handleTableScroll"
      >
        <span slot="factoryName" slot-scope="text">
          <strong>{{ text }}</strong>
        </span>
        <span slot="historyLoginCount" slot-scope="text">
          <strong>{{ text }}</strong>
        </span>
        <span slot="loginCount" slot-scope="text">
          <strong>{{ text }}</strong>
        </span>
        <span slot="total" slot-scope="text">
          <strong>{{ text }}</strong>
        </span>
      </a-table>
<!--    </div>-->

    <!-- 明细数据模态框 -->
    <a-modal
      :title="detailModalTitle"
      :visible="detailModalVisible"
      :width="1200"
      :footer="null"
      @cancel="detailModalVisible = false"
      wrapClassName="detail-modal-wrapper"
    >
      <!-- 添加导出按钮 -->
      <div style="margin-bottom: 10px;">
        <a-button type="primary" icon="download" @click="exportDetailData">{{ language['common.exportButton'] }}</a-button>
      </div>

      <!-- 添加滚动容器 -->
      <div class="detail-table-wrapper">
        <a-table
          :columns="detailColumns"
          :data-source="detailDataSource"
          :loading="detailLoading"
          :pagination="detailPagination"
          @change="handleDetailTableChange"
          size="middle"
          bordered
          :scroll="{ x: true, y: 800 }"
        >
          <span slot="sex" slot-scope="text">
            {{ formatSex(text) }}
          </span>
          <span slot="status" slot-scope="text">
            {{ formatStatus(text) }}
          </span>
        </a-table>
      </div>
    </a-modal>

  </a-card>
</template>

<script>
import { getAction, downFile } from '@/api/manage'
import moment from 'moment'
import { getDictItemsFromCache } from '@/api/api'
import { filterDictText } from '@/components/dict/JDictSelectUtil'

export default {
  name: 'LoginStatistics2',
  data() {
    return {
      queryForm: this.$form.createForm(this),
      dateFormat: 'YYYY-MM-DD',
      statisticsData: null,
      columns: [],
      dataSource: [],
      scrollX: 1200,
      chartData: null,
      chartInstance: null,
      customHeaderHtml: '',
      tableBodyElement: null,
      loading: false,
      fixedHeaderHtml: '',     // 新增：固定部分 HTML
      scrollHeaderHtml: '',    // 新增：滚动部分 HTML
      // 新增明细相关数据
      detailModalVisible: false,
      detailModalTitle: '',
      detailColumns: [],
      detailDataSource: [],
      detailLoading: false,
      detailPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `共 ${total} 条记录`,
      },
      currentDetailParams: {},
      sexList: [],
      statusList: [],
      userTypeList: [],
      queryValues: {}, // 保存查询值
    }
  },
  mounted() {
    this.setDefaultDate()
    this.searchQuery()
  },
  beforeDestroy() {
    if (this.tableBodyElement) {
      this.tableBodyElement.removeEventListener('scroll', this.handleNativeScroll);
    }
  },
  created() {
    // 初始化字典数据
    this.statusList = getDictItemsFromCache('user_status');
    this.userTypeList = getDictItemsFromCache('user_type_emp');
    this.sexList = getDictItemsFromCache('sex');
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    // 设置默认日期（最近30天）
    setDefaultDate() {
      const endTime = moment()
      const startTime = moment().subtract(29, 'days')

      this.queryForm.setFieldsValue({
        startTime: startTime,
        endTime: endTime
      })
    },

    // 查询数据
    searchQuery() {
      this.queryForm.validateFields((error, values) => {
        if (!error) {
          // 校验时间范围
          if (!values.startTime || !values.endTime) {
            this.$message.warning('请选择完整的时间范围');
            return;
          }

          // 校验开始时间不能大于结束时间
          if (values.startTime.isAfter(values.endTime)) {
            this.$message.warning('开始时间不能大于结束时间');
            return;
          }

          // 校验时间范围不能超过30天
          const daysDiff = values.endTime.diff(values.startTime, 'days');
          if (daysDiff > 30) {
            this.$message.warning('查询时间范围不能超过30天');
            return;
          }

          const params = {
            startTime: values.startTime ? values.startTime.format(this.dateFormat) : null,
            endTime: values.endTime ? values.endTime.format(this.dateFormat) : null
          }

          // 保存查询值
          this.queryValues = values;

          this.loading = true;
          getAction("/hhemp/emplog/getUserLoginStatByFactory",params).then(res => {
            if (res.success) {
              this.statisticsData = res.result
              this.generateTableData()
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    },

    // 重置查询条件
    searchReset() {
      this.queryForm.resetFields()
      this.setDefaultDate()
      this.searchQuery()
    },

    // 导出数据
    handleExport(fileName) {
      this.queryForm.validateFields((error, values) => {
        if (!error) {
          // 校验时间范围
          if (!values.startTime || !values.endTime) {
            this.$message.warning('请选择完整的时间范围');
            return;
          }

          // 校验开始时间不能大于结束时间
          if (values.startTime.isAfter(values.endTime)) {
            this.$message.warning('开始时间不能大于结束时间');
            return;
          }

          // 校验时间范围不能超过30天
          const daysDiff = values.endTime.diff(values.startTime, 'days');
          if (daysDiff > 30) {
            this.$message.warning('查询时间范围不能超过30天');
            return;
          }

          const params = {
            startTime: values.startTime ? values.startTime.format(this.dateFormat) : null,
            endTime: values.endTime ? values.endTime.format(this.dateFormat) : null
          }

          downFile('/hhemp/emplog/exportByFactory',params).then((data)=>{
            if (!data) {
              this.$message.warning("文件下载失败")
              return
            }
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}), fileName+'.xlsx')
            }else{
              let url = window.URL.createObjectURL(new Blob([data],{type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}))
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', fileName+'.xlsx')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          })
        }
      })
    },

    // 生成表格数据
    generateTableData() {
      if (!this.statisticsData) return

      const { dateList, factories, totalData } = this.statisticsData

      // 生成自定义表头HTML
      //this.customHeaderHtml = this.generateCustomHeaderHtml(dateList);

      // 2. 拆分生成 HTML (解决表头冻结问题)
      this.fixedHeaderHtml = this.generateFixedHeaderHtml();
      this.scrollHeaderHtml = this.generateScrollHeaderHtml(dateList);

      // 3. 生成列定义 (保持冻结两列)
      this.columns = [
        { title: '', dataIndex: 'factoryName', key: 'factoryName', width: 120, fixed: 'left', scopedSlots: { customRender: 'factoryName' } },
        { title: '', dataIndex: 'historyLoginCount', key: 'historyLoginCount', width: 100, fixed: 'left', align: 'right', scopedSlots: { customRender: 'historyLoginCount' } ,
          customRender: (text, record) => {
            if (text === null || text === '' || text === 0) {
              return <strong>{text}</strong>;
            }
            return <a onClick={() => this.showDetail(record, 'history')}><strong>{text}</strong></a>;
          }
        },
        { title: '', dataIndex: 'loginCount', key: 'loginCount', width: 100, fixed: 'left', align: 'right', scopedSlots: { customRender: 'loginCount' } ,
          customRender: (text, record) => {
            if (text === null || text === '' || text === 0) {
              return <strong>{text}</strong>;
            }
            return <a onClick={() => this.showDetail(record, 'current')}><strong>{text}</strong></a>;
          }
        },
        { title: ' ', dataIndex: 'total', key: 'total', width: 100, fixed: 'left',align: 'right', scopedSlots: { customRender: 'total' } ,
          customRender: (text, record) => {
            if (text === null || text === '' || text === 0) {
              return <strong>{text}</strong>;
            }
            return <a onClick={() => this.showDetail(record, 'total')}><strong>{text}</strong></a>;
          }
        }
      ];

      // 生成列定义
      /*this.columns = [
        {
          title: '',
          dataIndex: 'factoryName',
          key: 'factoryName',
          width: 120,
          fixed: 'left',
          scopedSlots: { customRender: 'factoryName' }
        }
      ];*/

      // 添加总计列
      /*this.columns.push({
        title: ' ', // 总计
        dataIndex: 'total',
        key: 'total',
        width: 100,
        fixed: 'left',
        scopedSlots: { customRender: 'total' }
      });*/

      // 添加日期列
      dateList.forEach((date, index) => {
        this.columns.push({
          title: ' ', // 临时标题，会被自定义表头覆盖
          dataIndex: `date_${index}`,
          key: `date_${index}`,
          width: 80,
          align: 'right',
          customRender: (text, record) => {
            if (text === null || text === '' || text === 0) {
              return <strong>{text}</strong>;
            }
            return <a onClick={() => this.showDailyDetail(record, date)}><strong>{text}</strong></a>;
          }
        });
      });

      // 生成数据源
      this.dataSource = []

      // 总计行
      const totalRow = {
        key: 'total',
        factoryName: '总计',
        //loginCount: totalData.totalUserCount,
        historyLoginCount: totalData.historyTotalUserCountAll,
        loginCount: totalData.totalUserCountAll,
        total: totalData.totalCount
      }
      dateList.forEach((date, index) => {
        totalRow[`date_${index}`] = totalData.dailyCounts[index];
      })
      this.dataSource.push(totalRow)

      // 厂区数据行
      factories.forEach((group, groupIndex) => {
        const row = {
          key: `factory_${groupIndex}`,
          factoryName: group.factoryName,
          historyLoginCount: group.historyTotalUserCountForFactory,
          //loginCount: group.totalUserCount,
          loginCount: group.totalUserCountForFactory,
          total: group.totalCount
        }
        group.dailyCounts.forEach((count, dateIndex) => {
          row[`date_${dateIndex}`] = count;
        })
        this.dataSource.push(row)
      })

      // 计算滚动宽度 - 精确匹配表头
      this.scrollX = 120 + 100 + 100  + 100 + dateList.length * 80;

      // 生成自定义表头HTML（在计算scrollX之后）
      /*this.$nextTick(() => {
        this.customHeaderHtml = this.generateCustomHeaderHtml(dateList);

        // 确保表头宽度与表格一致
        this.$nextTick(() => {
          this.syncHeaderWidth();
        });
      });*/

      // 关键：在 DOM 更新后设置滚动监听器
      this.$nextTick(() => {
        // 清理旧的监听器和元素，防止重复设置
        if (this.tableBodyElement) {
          this.tableBodyElement.removeEventListener('scroll', this.handleNativeScroll);
          this.tableBodyElement = null;
        }

        this.setupTableScrollListener();

        // 强制触发一次滚动，确保固定列和对齐被 AntD 正确计算
        if (this.tableBodyElement) {
          this.tableBodyElement.dispatchEvent(new Event('scroll'));
        }
      });
    },

    // 生成自定义表头HTML
    generateCustomHeaderHtml(dateList) {
      // 使用与表格相同的宽度
      const totalWidth = this.scrollX;

      return `        <table class="custom-header-table" style="width: ${totalWidth}px; border-collapse: collapse; table-layout: fixed; margin-bottom: 0;">
          <colgroup>
            <col style="width: 120px;">
            <col style="width: 100px;">
            <col style="width: 100px;">
            <col style="width: 100px;">
            ${dateList.map(() => '<col style="width: 80px;">').join('')}          </colgroup>
          <thead>
            <!-- 第一行 -->
            <tr style="height: 30px;">
              <th rowspan="3" style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; font-weight: bold; vertical-align: middle;">厂区</th>
              <th style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; font-weight: bold; vertical-align: middle;">总计</th>
              <th colspan="${dateList.length}" style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; font-weight: bold;">登录人次</th>
            </tr>
            <!-- 第二行 -->
            <tr style="height: 30px;">
              <th style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; vertical-align: middle; font-weight: normal;">日期</th>
              ${dateList.map(date =>
        `<th style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; vertical-align: middle; font-weight: normal;">${date}</th>`
      ).join('')}            </tr>
            <!-- 第三行 -->
            <tr style="height: 30px;">
              <th style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; vertical-align: middle; font-weight: normal;">星期</th>
              ${dateList.map(date =>
        `<th style="border: 1px solid #e8e8e8; background-color: #3260c9; color: #fff; text-align: center; vertical-align: middle; font-weight: normal;">${this.getWeekday(date)}</th>`
      ).join('')}            </tr>
          </thead>
        </table>
      `;
    },

    // 关键：生成冻结部分表头 HTML (120px + 100px)
    generateFixedHeaderHtml() {
      return `    <table class="login-statistics-fixed-header-table">
          <colgroup>
            <col class="login-statistics-col-width-120">
            <col class="login-statistics-col-width-100">
            <col class="login-statistics-col-width-100">
            <col class="login-statistics-col-width-100">
          </colgroup>
          <thead class="login-statistics-header-thead">
            <tr class="login-statistics-header-row-height">
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-font-bold login-statistics-header-vertical-middle" rowspan="3">厂区</th>
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-font-bold login-statistics-header-vertical-middle" rowspan="3">累计登录人数</th>
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-font-bold login-statistics-header-vertical-middle" rowspan="3">登录人数</th>
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-font-bold login-statistics-header-vertical-middle">总计</th>
            </tr>
            <tr class="login-statistics-header-row-height">
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-vertical-middle login-statistics-header-font-bold">日期</th>
            </tr>
            <tr class="login-statistics-header-row-height">
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-vertical-middle login-statistics-header-font-bold">星期</th>
            </tr>
          </thead>
        </table>
      `;
    },

    // 关键：生成滚动部分表头 HTML (日期部分)
    generateScrollHeaderHtml(dateList) {
      // 滚动部分的宽度就是日期列的总宽度
      const scrollWidth = dateList.length * 80;

      return `    <table class="login-statistics-scroll-header-table" style="width: ${scrollWidth}px;">
          <colgroup>
            ${dateList.map(() => '<col class="login-statistics-col-width-80">').join('')}      </colgroup>
          <thead class="login-statistics-header-thead">
            <tr class="login-statistics-header-row-height">
              <th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-font-bold" colspan="${dateList.length}">登录人次</th>
            </tr>
            <tr class="login-statistics-header-row-height">
              ${dateList.map(date =>
            `<th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-vertical-middle login-statistics-header-font-normal">${date}</th>`
          ).join('')}        </tr>
            <tr class="login-statistics-header-row-height">
              ${dateList.map(date =>
            `<th class="login-statistics-header-cell login-statistics-header-cell-border login-statistics-header-bg-primary login-statistics-header-text-white login-statistics-header-text-center login-statistics-header-vertical-middle login-statistics-header-font-normal">${this.getWeekday(date)}</th>`
          ).join('')}        </tr>
          </thead>

        </table>
      `;
    },

    // 同步表头宽度
    syncHeaderWidth() {
      if (this.$refs.table && this.$refs.headerContent) {
        const tableBody = this.$refs.table.$el.querySelector('.ant-table-body');
        if (tableBody) {
          // 同步滚动
          this.$refs.headerContainer.scrollLeft = tableBody.scrollLeft;
        }
      }
    },

    // 处理表头滚动
    handleHeaderScroll(e) {
      if (this.$refs.table) {
        const tableBody = this.$refs.table.$el.querySelector('.ant-table-body');
        if (tableBody) {
          tableBody.scrollLeft = e.target.scrollLeft;
        }
      }
    },

    // 处理表格滚动
    handleTableScroll(scrollData) {
      const headerContainer = this.$refs.headerContainer;

      if (headerContainer && scrollData && typeof scrollData.scrollLeft !== 'undefined') {
        // 直接将表格的水平滚动值赋给自定义表头容器
        headerContainer.scrollLeft = scrollData.scrollLeft;
      }
    },

    disabledEndDate(current) {
      // 禁用大于今天的日期
      return current && current > moment().endOf('day');
    },
    // 禁用开始日期大于今天的日期
    disabledStartDate(current) {
      return current && current > moment().endOf('day');
    },

    // 获取星期几
    getWeekday(dateString) {
      if (!dateString) return '';
      const date = moment(dateString, 'YYYY-MM-DD');
      if (!date.isValid()) return '';

      const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      return weekdays[date.day()];
    },

    /**
     * 【新增】设置表格 body 的原生滚动监听器，解决问题 1
     */
    setupTableScrollListener() {
      if (!this.$refs.table || this.tableBodyElement) {
        // 如果已经设置，则不再重复设置
        return;
      }

      // 准确获取到 AntD Table 内部负责水平滚动的 body 元素
      const tableBody = this.$refs.table.$el.querySelector('.ant-table-body');

      if (tableBody) {
        this.tableBodyElement = tableBody;

        // 移除 AntD 自带的 @scroll 监听（如果它能用的话），改用原生的
        // AntD 的 @scroll 属性是 props 并非原生事件，所以我们直接监听原生事件
        tableBody.addEventListener('scroll', this.handleNativeScroll);
      }
    },

    /**
     * 【新增】处理原生滚动事件，用于同步自定义表头
     */
    /*handleNativeScroll(e) {
      if (this.$refs.headerContainer) {
        // 使用原生 DOM 的 scrollLeft 来同步自定义表头
        this.$refs.headerContainer.scrollLeft = e.target.scrollLeft;
      }
    },*/
    handleNativeScroll(e) {
      if (this.$refs.scrollHeaderContainer) {
        // 使用表格的滚动值来同步滚动部分表头
        this.$refs.scrollHeaderContainer.scrollLeft = e.target.scrollLeft;
      }
    },

    // 显示明细数据
    async showDetail(record, type) {
      // 先设置参数并弹出窗口
      const params = {
        factoryName: record.factoryName !== '总计' ? record.factoryName : null,
        type: type, // 'history', 'current', 'total'
        startTime: this.queryValues.startTime ? this.queryValues.startTime.format(this.dateFormat) : null,
        endTime: this.queryValues.endTime ? this.queryValues.endTime.format(this.dateFormat) : null,
        // 根据type确定queryType
        queryType: type === 'total' ? 'LOGIN_COUNT' : 'USER_COUNT',
        pageNo: 1,
        pageSize: this.detailPagination.pageSize
      };

      this.currentDetailParams = params;
      this.detailModalTitle = `${record.factoryName} - ${this.getDetailTitle(type)}`;
      this.initDetailColumns();

      // 先弹出窗口
      this.detailModalVisible = true;

      // 再加载数据
      await this.loadDetailData(params);
    },

    // 显示每日明细数据
    async showDailyDetail(record, date) {
      // 先设置参数并弹出窗口
      const params = {
        factoryName: record.factoryName !== '总计' ? record.factoryName : null,
        date: date,
        type: 'daily',
        startTime: this.queryValues.startTime ? this.queryValues.startTime.format(this.dateFormat) : null,
        endTime: this.queryValues.endTime ? this.queryValues.endTime.format(this.dateFormat) : null,
        queryType: 'LOGIN_COUNT',
        pageNo: 1,
        pageSize: this.detailPagination.pageSize
      };

      this.currentDetailParams = params;
      this.detailModalTitle = `${record.factoryName} - ${date} 明细`;
      this.initDetailColumns();

      // 先弹出窗口
      this.detailModalVisible = true;

      // 再加载数据
      await this.loadDetailData(params);
    },

    // 获取明细标题
    getDetailTitle(type) {
      const titles = {
        'history': '累计登录明细',
        'current': '登录人数明细',
        'total': '总计明细',
        'daily': '每日明细'
      };
      return titles[type] || '明细数据';
    },

    // 初始化明细表格列
    initDetailColumns() {
      this.detailColumns = [
        {
          title: '登录账号',
          dataIndex: 'userId',
          width: 120,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '真实姓名',
          dataIndex: 'userName',
          width: 120,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '生日',
          dataIndex: 'birthday',
          width: 120,
          align: "center",
        },
        {
          title: '性别',
          dataIndex: 'sex',
          width: 80,
          align: "center",
          //scopedSlots: { customRender: 'sex' }
          customRender: (text) => {
            return filterDictText(this.sexList, text)
          },
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: 200,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '电话',
          dataIndex: 'phone',
          width: 120,
          align: "center",
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 100,
          align: "center",
          //scopedSlots: { customRender: 'status' }
          customRender: (text) => {
            return filterDictText(this.statusList, text)
          },
        },
        {
          title: '工号',
          dataIndex: 'workNo',
          width: 120,
          align: "center",
          customRender: function(t, r, index) {
            if(r.userType == 'employee'){
              return t;
            }else{
              return "";
            }
          },
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '座机号',
          dataIndex: 'telephone',
          width: 120,
          align: "center",
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          width: 150,
          align: "center",
        },
        {
          title: '用户类型',
          dataIndex: 'userType',
          width: 120,
          align: "center",
          customRender: (text) => {
            return filterDictText(this.userTypeList, text)
          },
        },
        {
          title: '登录时间',
          dataIndex: 'loginTime',
          width: 150,
          align: "center",
        },
        {
          title: '事业群',
          dataIndex: 'groupName',
          width: 150,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '事业处',
          dataIndex: 'bu',
          width: 150,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '厂区',
          dataIndex: 'factory',
          width: 150,
          align: "center",
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: '资位',
          dataIndex: 'position',
          width: 120,
          align: "center",
        },
        {
          title: '职称',
          dataIndex: 'jobTitle',
          width: 120,
          align: "center",
        }
      ];
    },

    // 加载明细数据
    async loadDetailData(params) {
      // 只有在窗口已经打开的情况下才显示loading
      if (this.detailModalVisible) {
        this.detailLoading = true;
      }
      try {
        const res = await getAction("/hhemp/emplog/getUserLoginDetailByFactory", params);
        if (res.success) {
          this.detailDataSource = res.result.records;
          this.detailPagination.total = res.result.total;
          this.detailPagination.current = res.result.current

        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('加载明细数据失败');
      } finally {
        this.detailLoading = false;
      }
    },

    // 处理明细表格分页变化
    handleDetailTableChange(pagination) {
      const params = {
        ...this.currentDetailParams,
        pageNo: pagination.current,
        pageSize: pagination.pageSize
      };

      this.currentDetailParams = params;
      this.detailPagination.current = pagination.current;
      this.detailPagination.pageSize = pagination.pageSize;
      this.loadDetailData(params);
    },

    // 格式化性别显示
    formatSex(sex) {
      const sexMap = {
        '1': '男',
        '2': '女'
      };
      return sexMap[sex] || sex;
    },

    // 格式化状态显示
    formatStatus(status) {
      const statusMap = {
        '1': '正常',
        '2': '冻结'
      };
      return statusMap[status] || status;
    },
    // 导出明细数据
    exportDetailData() {
      const params = {
        ...this.currentDetailParams,
        export: true
      };

      downFile('/hhemp/emplog/exportUserLoginDetailByFactory', params).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }

        const fileName = this.detailModalTitle + '.xlsx';
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            fileName
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      });
    },


  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 24px;
}
.custom-header-wrapper {
  position: relative;
  border: 1px solid #e8e8e8;
  border-bottom: 0 !important;
  background: #fff;
  z-index: 10;
  width: 100%;
  overflow: hidden;
}

/* 冻结部分表头 */
.fixed-header-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 420px;
  overflow: hidden;
  /*height: 90px;*/
  z-index: 11;
  background: #fff;
}

/* 滚动部分表头 */
.scroll-header-container {
  margin-left: 420px;
  overflow-x: hidden;
  overflow-y: hidden;
  /*height: 90px;*/
}

/* 修改为 */
.login-statistics-fixed-header-table,
.login-statistics-scroll-header-table {
  border-collapse: collapse;
  table-layout: fixed !important;
  margin-bottom: 0;
  width: 100%;
}

.login-statistics-fixed-header-table th,
.login-statistics-scroll-header-table th {
  padding: 8px 4px;
  font-size: 12px;
  white-space: nowrap;
}

/* 滚动条样式 */
.scroll-header-container::-webkit-scrollbar {
  height: 8px;
}

.scroll-header-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll-header-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.scroll-header-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

<!-- 全局样式，解决 scoped 限制 -->
<style>/* 确保自定义表格样式生效 */
 .login-statistics-table.custom-table {
   table-layout: fixed !important;
 }

.login-statistics-table.custom-table .ant-table {
  table-layout: fixed !important;
}

.login-statistics-table.custom-table .ant-table-content {
  width: 100% !important;
  overflow-x: auto !important;
}

.login-statistics-table.custom-table .ant-table-body {
  overflow-x: auto !important;
}

.login-statistics-table.custom-table .ant-table table {
  table-layout: fixed !important;
  width: auto !important;
  min-width: auto !important;
}

/* 精确控制固定列宽度 */
.login-statistics-table.custom-table .ant-table-fixed-left {
  width: 420px !important;
}

.login-statistics-table.custom-table .ant-table-fixed-left table {
  width: 420px !important;
}

/* 精确控制每一列的宽度 */
.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-thead > tr > th:first-child,
.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-tbody > tr > td:first-child {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
}

.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-thead > tr > th:nth-child(2),
.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-tbody > tr > td:nth-child(2) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-thead > tr > th:nth-child(3),
.login-statistics-table.custom-table .ant-table-fixed-left .ant-table-tbody > tr > td:nth-child(3) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

/* 精确控制日期列的宽度 */
.login-statistics-table.custom-table .ant-table-tbody > tr > td:not(.ant-table-row-expand-icon-cell) {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}

/* 确保表格容器没有额外边距 */
.login-statistics-table.custom-table .ant-table-container {
  border-top: none !important;
}

.login-statistics-table.custom-table .ant-table-body {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

/* 防止自动拉伸 */
.login-statistics-table.custom-table .ant-table-thead > tr > th,
.login-statistics-table.custom-table .ant-table-tbody > tr > td {
  width: auto !important;
  min-width: auto !important;
  max-width: none !important;
  white-space: nowrap;
}

/* 登录统计表专用样式 - 新增 */
.login-statistics-fixed-header-table,
.login-statistics-scroll-header-table {
  border-collapse: collapse;
  table-layout: fixed !important;
  margin-bottom: 0;
  width: 100%;
}

.login-statistics-fixed-header-table th,
.login-statistics-scroll-header-table th {
  padding: 8px 4px;
  font-size: 12px;
  white-space: nowrap;
}

/* 列宽定义 - 新增 */
.login-statistics-col-width-120 {
  width: 120px;
}

.login-statistics-col-width-100 {
  width: 100px;
}

.login-statistics-col-width-80 {
  width: 80px;
}

/* 表头单元格样式类 - 新增 */
.login-statistics-header-cell {
  /* 基础单元格样式 */
}

.login-statistics-header-cell-border {
  border: 1px solid #e8e8e8;
}

.login-statistics-header-bg-primary {
  background-color: #3260c9;
}

.login-statistics-header-text-white {
  color: #fff;
}

.login-statistics-header-text-center {
  text-align: center;
}

.login-statistics-header-font-bold {
  font-weight: bold;
}

.login-statistics-header-font-normal {
  font-weight: normal;
}

.login-statistics-header-vertical-middle {
  vertical-align: middle;
}

.login-statistics-header-thead {
  /* 头部样式 */
}

.login-statistics-header-row-height {
  height: 30px;
}
</style>